module.exports = __webpack_public_path__ + "img/rotate_left.78cfe33c.svg";